import { useTranslation } from "react-i18next"
import { Select, SelectGroup, SelectItem } from "../../../components/select/Select"
import { useIsMobileVersion } from "../../../hooks/mediaHooks"
import { LabelWithTooltip } from "./input/LabelWithTooltip"
import { DistributionTariff } from "@nano-portal/shared"

interface Props {
  value?: DistributionTariff
  onValueChange?: (value: DistributionTariff) => void
  hidePublicLighting?: boolean
}

export const DistributionTariffSelect = ({ value, onValueChange, hidePublicLighting }: Props) => {
  const isMobileVersion = useIsMobileVersion()
  const { t } = useTranslation("microsite")

  return (
    <Select
      defaultValue={DistributionTariff.D02d}
      label={<LabelWithTooltip label={t("distribution_tariff")} tooltip={t("distribution_tariff_tooltip")} />}
      width={isMobileVersion ? "max" : undefined}
      value={value}
      onValueChange={(value) => onValueChange?.(value as DistributionTariff)}
    >
      <SelectGroup label={t("households")}>
        <SelectItem value={DistributionTariff.D01d} text={t("distribution_tariff_d01d")} />
        <SelectItem value={DistributionTariff.D02d} text={t("distribution_tariff_d02d")} />
        <SelectItem value={DistributionTariff.D25d} text={t("distribution_tariff_d25d")} />
        <SelectItem value={DistributionTariff.D26d} text={t("distribution_tariff_d26d")} />
        <SelectItem value={DistributionTariff.D27d} text={t("distribution_tariff_d27d")} />
        <SelectItem value={DistributionTariff.D35d} text={t("distribution_tariff_d35d")} />
        <SelectItem value={DistributionTariff.D45d} text={t("distribution_tariff_d45d")} />
        <SelectItem value={DistributionTariff.D57d} text={t("distribution_tariff_d57d")} />
        <SelectItem value={DistributionTariff.D61d} text={t("distribution_tariff_d61d")} />
      </SelectGroup>

      <SelectGroup label={t("tradesmen")}>
        <SelectItem value={DistributionTariff.C01d} text={t("distribution_tariff_c01d")} />
        <SelectItem value={DistributionTariff.C02d} text={t("distribution_tariff_c02d")} />
        <SelectItem value={DistributionTariff.C03d} text={t("distribution_tariff_c03d")} />
        <SelectItem value={DistributionTariff.C25d} text={t("distribution_tariff_c25d")} />
        <SelectItem value={DistributionTariff.C26d} text={t("distribution_tariff_c26d")} />
        <SelectItem value={DistributionTariff.C27d} text={t("distribution_tariff_c27d")} />
        <SelectItem value={DistributionTariff.C35d} text={t("distribution_tariff_c35d")} />
        <SelectItem value={DistributionTariff.C45d} text={t("distribution_tariff_c45d")} />
        <SelectItem value={DistributionTariff.C46d} text={t("distribution_tariff_c46d")} />
        <SelectItem value={DistributionTariff.C55d} text={t("distribution_tariff_c55d")} />
        <SelectItem value={DistributionTariff.C56d} text={t("distribution_tariff_c56d")} />
        {!hidePublicLighting && <SelectItem value={DistributionTariff.C62d} text={t("distribution_tariff_c62d")} />}
      </SelectGroup>
    </Select>
  )
}
